import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { PSPMarkdownContent } from 'components/molecules';
import './IconContentItem.scss';

export const IconContentItem = ({ className, icon, title, titleProps, description, descriptionProps, alt, iconProps, ...rest }) => {
  const mergedTitleProps = {
    ...titleProps,
    heading: {
      ...titleProps?.heading,
      className: classnames('icon-content-item__title', titleProps?.heading?.className)
    }
  };

  const mergedDescriptionProps = {
    ...descriptionProps,
    paragraph: {
      ...descriptionProps?.paragraph,
      className: classnames('icon-content-item__desc', descriptionProps?.paragraph?.className)
    }
  };

  return (
    <figure className={classnames('icon-content-item', className)} {...rest}>
        {icon && (
          <div className="icon-content-item__icon-wrapper">
              <img 
                src={icon} 
                alt={alt} 
                className={classnames('icon-content-item__icon', iconProps?.className)} 
                {...iconProps} 
              />
          </div>
        )}
        <figcaption className="icon-content-item__content">
            {title && (
              <PSPMarkdownContent content={title} additionalProps={mergedTitleProps}/>
            )}
            {description && (
              <PSPMarkdownContent
                content={description}
                additionalProps={mergedDescriptionProps} 
              />
            )}
        </figcaption>
    </figure>
  );
};

IconContentItem.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleProps: PropTypes.object,
  description: PropTypes.string,
  descriptionProps: PropTypes.object,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  alt: PropTypes.string,
  iconProps: PropTypes.object,
};

IconContentItem.defaultProps = {
  className: '',
  titleProps: {},
  description: '',
  descriptionProps: {},
  icon: null,
  alt: '',
  iconProps: {},
};

export default IconContentItem;
